<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ct" id="heading_id_2">Contents</h1>
<p class="toc-fm"><a class="calibre4" href="#/OEBPS/Text/preface#pageix">Preface</a></p>
<p class="toc-fm"><a class="calibre4" href="#/OEBPS/Text/acknowledgment#pagexvii">Acknowledgments </a></p>
<p class="para"><br class="calibre2"/></p>
<p class="toc-level"><a class="calibre4" href="#/OEBPS/Text/part01#page1">Part One | Theories of Community </a></p>
<p class="para"><br class="calibre2"/></p>
<p class="toc-level1"><a class="calibre4" href="#/OEBPS/Text/ch01#page3"><span class="toc-level2-label">1</span> Nancy contra Stevens </a></p>
<p class="para"><br class="calibre2"/></p>
<p class="toc-level"><span class="calibre4" href="#/OEBPS/Text/part02#page37" title="Link target outside of Sample">Part Two | Franz Kafka: Premonitions of Auschwitz </span></p>
<p class="para"><br class="calibre2"/></p>
<p class="toc-level1"><span class="calibre4" href="#/OEBPS/Text/ch02#page39" title="Link target outside of Sample"><span class="toc-level2-label">2</span> Foreshadowings of Auschwitz in Kafka's Writings </span></p>
<p class="toc-level1"><span class="calibre4" href="#/OEBPS/Text/ch03#page67" title="Link target outside of Sample"><span class="toc-level2-label">3</span> The Breakdown of Community and the Disabling of Speech Acts in Kafka's <em class="italic">The Trial</em> </span></p>
<p class="toc-level1"><span class="calibre4" href="#/OEBPS/Text/ch04#page103" title="Link target outside of Sample"><span class="toc-level2-label">4</span> <em class="italic">The Castle</em>: No <em class="italic">Mitsein</em>, No Verifiable Interpretation </span></p>
<p class="para"><br class="calibre2"/></p>
<p class="toc-level"><span class="calibre4" href="#/OEBPS/Text/part03#page147" title="Link target outside of Sample">Part Three | Holocaust Novels </span></p>
<p class="para"><br class="calibre2"/></p>
<p class="toc-level1"><span class="calibre4" href="#/OEBPS/Text/prologue#page149" title="Link target outside of Sample"><span class="toc-level2-label">  </span> Prologue: Community in Fiction after Auschwitz </span></p>
<p class="toc-level1"><span class="calibre4" href="#/OEBPS/Text/ch05#page155" title="Link target outside of Sample"><span class="toc-level2-label">5</span> Three Novels about the Shoah </span></p>
<p class="toc-level1"><span class="calibre4" href="#/OEBPS/Text/ch06#page177" title="Link target outside of Sample"><span class="toc-level2-label">6</span> Imre Kertész's <em class="italic">Fatelessness</em>: Fiction as Testimony </span></p>
<p class="para"><br class="calibre2"/></p>
<p class="toc-level"><span class="calibre4" href="#/OEBPS/Text/part04#page229" title="Link target outside of Sample">Part Four | Fiction after Auschwitz </span></p>
<p class="para"><br class="calibre2"/></p>
<p class="toc-level1"><span class="calibre4" href="#/OEBPS/Text/ch07#page231" title="Link target outside of Sample"><span class="toc-level2-label">7</span> Morrison's <em class="italic">Beloved</em> </span></p>
<p class="para"><br class="calibre2"/></p>
<p class="toc-fm"><span class="calibre4" href="#/OEBPS/Text/coda#page271" title="Link target outside of Sample">Coda </span></p>
<p class="toc-fm"><span class="calibre4" href="#/OEBPS/Text/notes_split_000#page273" title="Link target outside of Sample">Notes </span></p>
<p class="toc-fm"><span class="calibre4" href="#/OEBPS/Text/index#page301" title="Link target outside of Sample">Index of Names, Titles of Works, and Characters </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?f58ad290